var classes = {"productCardImageWrapper":"ruzMG","quickViewButton":"c7vsI","productCardActions":"Qj9yq","shareButton":"lWEpv"};

export { classes as default };
